import {
  Component,
  Input,
  inject,
  ChangeDetectionStrategy,
} from '@angular/core';
import { SamplesListComponent } from '@app/modules/service-data/components/sample/samples-list/samples-list.component';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-sample-list-dialog',
  imports: [TranslateModule, SamplesListComponent],
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: './sample-list-dialog.component.html',
})
export class SampleListDialogComponent {
  protected modalRef = inject(NgbActiveModal);

  @Input() sampleIds: string[];
  @Input() serviceDataId: string;
}
